<template>
  <div v-if="eventData || videoDialogVisible">
    <el-dialog
      v-if="eventData"
      :title="`${area === 'public' ? '公區' : '私區'}告警詳情`"
      :visible.sync="visible"
      @close="handleClose"
      @closed="handleClosed"
    >
      <!-- 整個表單 -->
      <div class="content-container">
        <!-- 每個欄位 -->
        <div class="content-wrapper">
          <!-- 欄位標題 -->
          <div v-for="key in ['TagMean', 'CreatedTime', 'AssetPosition']" :key="key" class="row">
            <div class="key">{{ eventDetailStructure[key] }}</div>
            <div class="value regular" :class="{bold: key === 'AssetPosition'}">
              {{ eventData[key] }}
            </div>
          </div>
        </div>
        <div class="content-wrapper">
          <div v-for="key in ['TagLevel', 'TagName', 'EventStatus']" :key="key" class="row">
            <div class="key">{{ eventDetailStructure[key] }}</div>
            <div class="value regular" :class="{emergency: eventData[key] === 'L4-災害級警報', warning: eventData[key] === 'L3-高程度警報'}">
              {{ key === 'EventStatus' ? (eventData[key] ? '正常' : '異常') : eventData[key] }}
            </div>
          </div>
        </div>
        <div class="content-wrapper btn-container">
          <el-tooltip
            :disabled="firstVideoLogStatus === videoBtnStatus.hasVideo"
            :content="$t(firstVideoLogStatus === videoBtnStatus.noVideo ? 'BAAlert.NoVideoTipMsg' : 'BAAlert.VideoTipMsg')"
            placement="bottom"
          >
            <el-button
              type="primary"
              size="mini"
              :disabled="firstVideoLogStatus !== videoBtnStatus.hasVideo"
              class="btn"
              :class="firstVideoLogStatus === videoBtnStatus.hasVideo ? '' : 'disabled'"
              @click="openFirstVideo"
            >
              <span class="content">
                <img
                  src="@/assets/img/baalert/play-filled.svg"
                  alt="play-filled"
                  class="img"
                />
                {{ eventDetailStructure.VideoBtn }}
              </span>
            </el-button>
          </el-tooltip>
        </div>
        <div class="content-wrapper History">
          <div class="key">{{ eventDetailStructure.History }}</div>
          <div class="value history">
            <el-table
              :data="eventData.StageList"
              style="width: 100%"
            >
              <el-table-column
                v-for="[en,zh] in Object.entries(eventReportHistoryStructure)"
                :key="en"
                :prop="en"
                :label="zh"
                width="auto"
              >
                <template slot-scope="scope">
                  <pre v-if="en === 'Reporter'">{{ getDeviceModel(scope.row[en]) }}</pre>
                  <pre v-else class="regular">{{ scope.row[en] || '-' }}</pre>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="content-wrapper Log">
          <div class="key">{{ eventDetailStructure.Log }}</div>
          <div class="value log">
            <el-table
              :data="eventData.LogList"
              style="width: 100%"
            >
              <el-table-column
                v-for="[en,zh] in Object.entries(simpleLogStructure)"
                :key="en"
                :prop="en"
                :label="zh"
                width="auto"
              >
                <template slot-scope="scope">
                  <template v-if="en === 'HasVideo'">
                    <span v-if="getLogVideoState(scope.row) === videoBtnStatus.hasVideo" class="column-btn-container">
                      <el-button
                        type="primary"
                        size="mini"
                        class="btn"
                        plain
                        @click="handleClickLogVideo(scope.row)"
                      >
                        <span class="content">
                          <img
                            src="@/assets/img/baalert/play-filled-plain.svg"
                            alt="play"
                            class="img"
                          />
                          {{ $t('BAAlert.PlayVideo') }}
                        </span>
                      </el-button>
                    </span>
                    <pre v-else-if="getLogVideoState(scope.row) === videoBtnStatus.expired" class="regular expired">
                      <span>{{ $t('BAAlert.Expired') }}</span>
                      <el-tooltip
                        :content="$t('BAAlert.VideoTipMsg')"
                        placement="top"
                      >
                        <img
                          src="@/assets/img/baalert/info.svg"
                          alt="info"
                          class="img"
                        />
                      </el-tooltip>
                    </pre>
                    <pre v-else class="regular">-</pre>
                  </template>
                  <template v-else-if="en === 'videoExpiredTime'">
                    <pre class="regular">{{ scope.row.HasVideo ? scope.row.videoExpiredTime || '-' : '-' }}</pre>
                  </template>
                  <template v-else>
                    <pre class="regular">{{ scope.row[en] || '-' }}</pre>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-button
        :type="eventData.CurrentStageType.includes('結案') ? 'primary' : 'plain'"
        @click="handleClose"
      >
        確定
      </el-button>
      <el-button
        v-if="!eventData.CurrentStageType.includes('結案')"
        type="primary"
        @click="handleClickReport(eventData.EventId, area)"
      >
        {{ $t('BAAlert.GoToReport') }}
      </el-button>
    </el-dialog>
    <EventDetailVideoDialog
      :visible.sync="videoDialogVisible"
      :video-src="videoSrc"
      @closed="handleVideoDialogClosed"
    />
  </div>
</template>

<script>
import { eventDetailStructure, eventReportHistoryStructure, simpleLogStructure, videoBtnStatus } from '../models'
import { EventError } from '../models/error'
import { getDeviceModel } from '@/js/models/appleDevice'
import { goToParent, processEventList, isVideoExpired } from '../utils'
import EventDetailVideoDialog from './EventDetailVideoDialog'
export default {
  components: {
    EventDetailVideoDialog
  },
  props: {
  },
  data () {
    return {
      visible: false,
      videoDialogVisible: false,
      videoSrc: null,
      eventData: null,
      eventDetailStructure,
      eventReportHistoryStructure,
      simpleLogStructure,
      videoBtnStatus,
      isOpenEventing: false,
      area: 'public',
      firstVideoLogStatus: videoBtnStatus.noVideo,
      firstVideoUrl: null,
      getDeviceModel
    }
  },
  methods: {
    getLogVideoState (logRow) {
      if (!logRow.HasVideo) return videoBtnStatus.noVideo

      if (isVideoExpired(logRow.WarningTime)) return videoBtnStatus.expired
      return videoBtnStatus.hasVideo
    },
    getLogVideoStateText (logRow) {
      const state = this.getLogVideoState(logRow)
      if (state === videoBtnStatus.expired) return this.$t('BAAlert.Expired')
      return '-'
    },
    openFirstVideo () {
      if (this.firstVideoUrl) {
        this.videoSrc = this.firstVideoUrl
        this.videoDialogVisible = true
      }
    },
    handleClickLogVideo (logRow) {
      if (!logRow.LogId) return
      this.openAlertVideoDialog(logRow.LogId)
    },
    async openAlertVideoDialog (id) {
      if (!id) return
      try {
        const res = await apiBaAlert.getLogFileById(id)
        if (!res.data.Url) throw new EventError()
        this.videoSrc = res.data.Url
        this.videoDialogVisible = true
      } catch (error) {
        this.$confirm(this.$t('BAAlert.VideoErrorMsg'), {
          confirmButtonText: this.$t('General.OK'),
          showCancelButton: false,
          type: 'warning'
        })
      }
    },
    handleVideoDialogClosed () {
      this.videoSrc = null
    },
    resetFirstVideoStatus () {
      this.firstVideoUrl = null
      this.firstVideoLogStatus = videoBtnStatus.noVideo
    },
    async openEventDetail (id, area) {
      if (this.isOpenEventing) return
      this.area = area === '' ? 'public' : area
      this.isOpenEventing = true
      if (id) {
        try {
          const requestAPI = area === 'private' ? apiBaAlert.getPrivateEventById : apiBaAlert.getEventById
          const res = await requestAPI(id)
          // 無此事件
          if (!res.data) throw new EventError()
          // 尚不支援 L0
          if (res.data.TagLevel === 0) throw new EventError(1)
          this.eventData = processEventList([res.data])[0]
          if (!this.eventData.FirstVideoLogId) {
            this.resetFirstVideoStatus()
            this.visible = true
            this.isOpenEventing = false
            return
          }
          try {
            const firstVideoLog = await apiBaAlert.getLogFileById(this.eventData.FirstVideoLogId)
            const warningTime = firstVideoLog.data.WarningTime
            if (!warningTime) {
              this.resetFirstVideoStatus()
              this.visible = true
              this.isOpenEventing = false
              return
            }
            const isExpired = isVideoExpired(warningTime)
            this.firstVideoLogStatus = isExpired ? videoBtnStatus.expired : videoBtnStatus.hasVideo
            this.firstVideoUrl = firstVideoLog.data.Url
            // 未過期但無影片 URL，則視為無影片
            if (!isExpired && !this.firstVideoUrl) {
              this.resetFirstVideoStatus()
            }
          } catch {
            this.resetFirstVideoStatus()
          }
          this.visible = true
        } catch (error) {
          const message = error.name === 'EventError' ? error.message : '無此事件'
          // 例外處理
          this.$confirm(message, {
            confirmButtonText: this.$t('General.OK'),
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          }).finally(() => {
            // 取消或確定則關閉彈窗並返回路由
            goToParent(this.$route, this.$router)
          })
        }
      }
      this.isOpenEventing = false
    },
    handleClose (isGoToParent = true) {
      this.visible = false
      // 如果是切換路由導致關閉就不要返回根路由
      if (this.$route.name === 'reportEventById') isGoToParent = false
      if (isGoToParent) {
        goToParent(this.$route, this.$router)
      }
    },
    handleClosed () {
      // 將資料初始化
      this.eventData = null
      this.videoDialogVisible = false
      this.videoSrc = null
    },
    handleClickReport (id, area) {
      this.$emit('handleClickReport', id, area)
    }
  }
}
</script>

  <style lang="scss" scoped>
::v-deep .el-table {
  @include basicTable(true);
}
::v-deep .el-dialog {
  @include basicDialog();
  .content-container {
    display: flex;
    flex-wrap: wrap;
    gap: 40px 16px;
    margin-bottom: 40px;
    .content-wrapper {
      text-align: start;
      display: flex;
      min-height: 50px;
      height: auto;
      flex: 0 0 33.33%;
      flex-direction: column;
      gap: 16px;
      .row {
        display: flex;
        gap: 16px;
      }
      .key {
        color: $mainFontColor;
        $key_size: 17px;
        font-weight: bold;
        font-size: $key_size;
        min-width: 70px;
      }
      .value {
        flex: 0 1 100%;
        .el-dropdown-link {
          cursor: pointer;
        }
        &.bold {
          font-weight: bold;
        }
      }
      &.History,
      &.Log {
        flex: 0 0 100%;
        flex-direction: column;
        width: 100%;
        .value {
          flex: 1 1 0%;
        }
      }
    }
    .btn-container {
      display: flex;
      margin-left: auto;
      justify-content: center;
      align-items: flex-end;
      flex: 0 0 25%;
    }
    .column-btn-container {
      display: flex;
      justify-content: center;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      .content{
        display: inline-flex;
        align-items: center;
      }
      &.disabled {
        background-color: $bgDark1;
        border-color: $bgDark1;
      }
      .img {
        height: 20px;
        width: 20px;
        margin-right: 6px;
      }
    }
    .expired {
      flex-direction: row;
      align-items: center;
      display: flex;
      gap: 7px;
      justify-content: center;
      color: $dangerColor;
      .img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
